import { IDeleteNovosNegociosUseCase } from "../../../presentation/useCases/delete/delete_novos_negocios_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * DeleteNovosNegociosUseCase
 */

export class DeleteNovosNegociosUseCase implements IDeleteNovosNegociosUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idNovosNegocios: number): Promise<void> {
    await this.repository.deleteNovosNegociosById(idNovosNegocios);

  }
}
